<template>
    <div v-bind:class="{'dragButton-transparent':transparent}" class="wb-room-conf-btn-anchor" :style="{'top': top + 'px', 'left': left + 'px'}"
         @mousedown="$emit('mousedown', $event)"
         @click="$emit('click', $event)">
        <div class="wb-room-conf-btn" :class="classes">
            <component v-bind:is="svg"/>
        </div>
    </div>
</template>

<script>
import SVGPlusButton from '@/UI/Components/SVG/SVGPlusButton.vue';
import SVGMinusButton from '@/UI/Components/SVG/SVGMinusButton.vue';
import SVGResizeH from '@/UI/Components/SVG/SVGResizeH.vue';
import SVGResizeV from '@/UI/Components/SVG/SVGResizeV.vue';
import { roomConfigButtonStyles } from '@/Constants/roomConfigButtonStyles';

export default {
    name: 'OverlayRoomConfigButton',
    components: { SVGResizeV, SVGResizeH, SVGMinusButton, SVGPlusButton },
    emits: [
        'mousedown',
        'click',
    ],
    props: [
        'top',
        'left',
        'type',
        'svg',
        'transparent',
    ],
    data() {
        return {
            types: roomConfigButtonStyles,
        };
    },
    computed: {
        classes() {
            return this.types[this.type];
        },
    },
};
</script>

<style scoped lang="scss">
@import "CSS/common.scss";
@import "CSS/colors.scss";
@import "CSS/animations.scss";

.wb-room-conf-btn-anchor {
    @include wb-c-flex-center;
    height: 0;
    width: 0;
    position: absolute;
    z-index: 200;
}

.wb-room-conf-btn {
    @include wb-c-flex-center;
    @include button-smooth;
    width: 24px;
    height: 24px;
    background-color: $gray1;
    color: $darkBlue;
    flex-grow: 0;
    flex-shrink: 0;
    cursor: pointer;
    user-select: none;
}

.wb-room-conf-btn:hover {
    background-color: $white;
}

.wb-room-conf-btn:active {
    background-color: $white;
    color: $green1;
}

.wb-top-left-r {
    border-top-left-radius: 12px;
}

.wb-top-right-r {
    border-top-right-radius: 12px;
}

.wb-bot-left-r {
    border-bottom-left-radius: 12px;
}

.wb-bot-right-r {
    border-bottom-right-radius: 12px;
}
.dragButton-transparent{
  pointer-events: none;
}
</style>
